import api from "../api";

export default class CollectService {

    static fetchUserProjectInfo() { return api.get('collect/questionnaires/user/project/info') }
    static fetchQuestions(project_id,answers=1,flag='dodoso', is_analysis=0) {
        return api.get(`collect/questionnaires/list/${project_id}/${answers}/${flag}/${is_analysis}`)}
    static fetchQuestionsForms(project_id, form_id,answers=1,is_monitoring=0) {
        return api.get(`collect/questionnaires/${project_id}/${form_id}/forms/${answers}/${is_monitoring}`)}
    static fetchQuestionsFormsAnalyse(project_id, form_id,answers=1) {return api.get(`collect/questionnaires/${project_id}/${form_id}/analyse`)}
    static fetchQuestionsFormsVerification(project_id, form_id) {
        return api.get(`collect/questionnaires/monitoring/verification/${project_id}/${form_id}`)}
    static createAnswer(data) {return api.post(`collect/questionnaires/create/answer`,data)}

    static fetchQuestionsMonitoring(project_type_id,answers=0,flag='zonal_monitoring') {
        return api.get(`collect/questionnaires/monitoring/list/${project_type_id}/${answers}/${flag}`)}

    static fetchQuestionsMonitoringForms(form_id,answers=1) {
        return api.get(`collect/questionnaires/monitoring/${form_id}/form/${answers}`)}

    static fetchCcroCounter(){
        return api.get('collect/ccro/parcelcount')
    }

    static fetchParcelsMap(village_id, stage) {
        return api.get(`collect/ccro/parcels/map?village_id=${village_id}&stage=${stage}`)
    }

}
export { CollectService };
